import api from 'api';

export const loadApplications = api(
  'GET /api/influencers-master-campaigns/fields/applications'
);

export const loadNetworks = api(
  'GET /api/influencers-master-campaigns/fields/networks'
);

export const loadPlatforms = api(
  'GET /api/influencers-master-campaigns/fields/platforms'
);

export const loadBriefs = api(
  'GET /api/influencers-master-campaigns/fields/briefs'
);

export const loadPromoCodes = api(
  'GET /api/influencers-master-campaigns/fields/promo-codes'
);

export const loadLandingPages = api(
  'GET /api/influencers-master-campaigns/fields/conversion-pages'
);

export const loadAgencies = api(
  'GET /api/influencers-master-campaigns/fields/agencies'
);

export const loadCustomModels = api(
  'GET /api/influencers-master-campaigns/fields/cost-models'
);
